<template src="./Edit.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
  props: {
    itemId: {
      type: Number,
      required: true,
    },
  },
  created() {
        this.$store.dispatch("lookups/getProcedures");

    this.$store.dispatch("lookups/getPaymentAccounts");
    this.$store.dispatch("invoices/getForEdit", this.itemId).then((res) => {
      this.vm = res
      this.vm.patientId = res.id;
      this.vm.fileNo = res.fileNo;
      this.vm.fullName = res.fullName;
      this.vm.invoiceDate = res.invoiceDate;
      this.vm.paymentTypes = res.paymentTypes!= null ?res.paymentTypes.split(",").map(Number):[];
      this.vm.services = res.services;
      this.vm.discountType = res.discountType;
      this.vm.discount = res.discount;
      
    });
   
  },
  computed: {
    paymentTypes() {
      return this.$store.state.lookups.paymentAccounts;
    },
    itemPriceList() {
      return this.$store.state.lookups.itemPriceList || [];
    },
    totalAmount(){
   if(this.vm.services.length == 0) return 0;
    else{
     var sum = 0;
 this.vm.services.forEach(x => {
            sum += (x.discount > 0 &&  x.discount != null )? (x.price -(x.price * (x.discount / 100))):x.price ;
            //sum += (x.price * (x.discount / 100))
       });       if(this.vm.discountType == 1 && this.vm.discount != null) sum-= this.vm.discount;
       else if(this.vm.discountType == 2 && this.vm.discount != null) sum-= sum * (this.vm.discount/100);
      return sum;
    }
},
    procedures() {
      return [{
        value: "خدمات قسم التجميل الجراحي",
        label: "خدمات قسم التجميل الجراحي"
      },
      {
        value: "خدمات قسم التجميل اللاجراحي",
        label: "خدمات قسم التجميل اللاجراحي"
      },
      {
        value: "خدمات قسم التغذية",
        label: "خدمات قسم التغذية"
      },
      {
        value: "خدمات قسم العناية بالبشرة",
        label: "خدمات قسم العناية بالبشرة"
      },
      {
        value: "خدمات قسم الليزر",
        label: "خدمات قسم الليزر"
      }]
      // return  this.$store.state.lookups.procedures.filter(x => x.value != "الاصول الثابتة" &&  x.value !=  "خدمات تحاليل")
    },
    DiscountType(){
      return [
        {value :1,label:"قيمة"},
        {value :2,label:"نسبة"},
      ]
    },
  },
  data() {
    return {

      vm: {
          discountType: null,
        discount: null,
      
        patientId: null,
        invoiceDate: null,
        services: [],
      },
      service: {
        serviceName: null,
        price: null,
        discount: null,
      },
      servicePrice: null,
      analysas: {
        analysisGroupId: null,
        analysisId: null,
        price: null,
      },
      indexItem: null,
      editFlag: false,
      headersService: [
        { text: 'اسم الخدمة', value: 'serviceName' },
        { text: 'السعر ', value: 'price' },
        { text: 'التخفيض ', value: 'discount' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],

    
  procedureId:null,
    };
  },
  methods: {
    getServices(){
          this.$store.dispatch("lookups/GetItemByProcedure", this.procedureId);
    },  getPrice() {
      this.service.price = null;
      let service = this.itemPriceList.find(x => x.itemName == this.service.serviceName);
      this.service.price = service.price;

    },
    confirm() {
      if (this.vm.services.length == 0) {
        showAlert(`يجب ادخال عنصر واحد على الاقل`);
        return false;
      }
      this.$store
        .dispatch("invoices/edit", { id: this.itemId, payload: this.vm })
        .then(() => {
          this.back();
        })
        .catch(() => { });
    }, getAnalysis() {
      this.$store.dispatch("lookups/getAnalysis", this.analysas.analysisGroupId);

    },

    AddItem() {
      if (this.service.serviceName == null) {
        showAlert(`يجب اختيار الخدمة `);
        return false;
      }
      if (this.service.price == null) {
        showAlert(`يجب ادخال السعر `);
        return false;
      }
      var Index = this.vm.services.findIndex(x => x.serviceName == this.service.serviceName);
      if (Index != -1) {
        showAlert(`لا يمكن اضافة نفس الخدمة اكثر من مرة   `);
        return false;
      }
      let service = this.itemPriceList.find(x => x.itemName == this.service.serviceName);
      this.vm.services.push({
        serviceName: this.service.serviceName,
        serviceCode: service.itemCode,
        price: this.service.price,
        discount: this.service.discount,
      });
      this.service.serviceName = null;
      this.service.price = null;
      this.service.discount = null;
      //this.$refs.info.reset();
    },

    removeItem(index) {
      this.vm.services.splice(index, 1);
    },

    //----------------------------------------------------//


    back() {
      this.$emit("back");
    },
  },
};
</script>